import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSigilContext } from '../../context/sigilContext';

const InteractiveCripto = () => {
    const { criptoText } = useSigilContext();
    const [strickenIndexes, setStrickenIndexes] = useState(new Set());

    if (!criptoText) return null;

    // Procesar el texto: conservar solo letras, pasar a mayúsculas y quitar espacios
    const letters = criptoText
        .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ]/g, '')
        .toUpperCase()
        .split('');

    const toggleStrike = (index) => {
        setStrickenIndexes((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.add(index);
            }
            return newSet;
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                justifyContent: 'center',
                padding: '10px 0',
            }}
        >
            {letters.map((letter, index) => (
                <Box
                    key={`${letter}-${index}`}
                    onClick={() => toggleStrike(index)}
                    sx={{
                        width: { xs: 35, md: 45 },
                        height: { xs: 35, md: 45 },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px solid',
                        borderColor: strickenIndexes.has(index) ? 'rgba(255, 255, 255, 0.3)' : 'primary.main',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        backgroundColor: strickenIndexes.has(index) ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            borderColor: 'secondary.main',
                            transform: 'scale(1.05)',
                        },
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 'bold',
                            color: strickenIndexes.has(index) ? 'text.disabled' : 'text.primary',
                            textDecoration: strickenIndexes.has(index) ? 'line-through' : 'none',
                            userSelect: 'none',
                            opacity: strickenIndexes.has(index) ? 0.5 : 1,
                        }}
                    >
                        {letter}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default InteractiveCripto;
